var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainTemplate',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"md":"6"}},[_c('projectStartCardVue')],1),_c('v-col',{attrs:{"md":"6"}},[_c('projectAlertCardVue')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }